<ng-template #snackBarTemplate>
  <div>
    <span>
      @switch (currentAlert.type) {
        @case ('success') {
          <mat-icon>check</mat-icon>
        }
        @case ('error') {
          <mat-icon style="color: #ea5901;" >report_problem</mat-icon>
        }
        @case ('warning') {
          <mat-icon>warning</mat-icon>
        }
        @default {
          <mat-icon fontSet="ngi" fontIcon="info-circle"></mat-icon>
        }
      }
    </span>
    {{ currentAlert.message | translate }}
    <!-- {{ "'alert.login-failed'" | translate }} -->
    <!-- {{ currentAlert.message | translate }} -->
  </div>
</ng-template>


<style>
  /* .alertexamples {
  display: block;
  position: fixed;
  z-index: 1001;
  top: 160px;
  left: 30px;
  background: #ffd000cd;
  padding: 30px;
  border-radius: 6px;
}

@media (max-width: 599px) {
.alertexamples {
display: none;
}
} */
</style>
<!--
<div class="alertexamples" style="">

  <button style="margin:5px" mat-flat-button color="primary" (click)="openSnackBar('A snackbar test')">Snackbar 1</button>
  <br>
    <button style="margin:5px" mat-flat-button color="accent"  (click)="alertService.success('A snackbar test', {'autoClose': true , 'AlertType':'success',  'horizontalPos':'left', 'verticalPos':'bottom','fade':true})">Snackbar succes</button>
    <br>
      <button style="margin:5px" mat-flat-button color="accent"  (click)="alertService.error('A snackbar test', {'autoClose': true , 'AlertType':'error',  'horizontalPos':'center', 'verticalPos':'bottom','fade':true})">Snackbar error</button>
      <br>
        <button style="margin:5px" mat-flat-button color="accent"  (click)="alertService.info('A snackbar test', {'autoclose':true, 'AlertType':'info'})">Snackbar info</button>
        <br>
          <button style="margin:5px" mat-flat-button color="accent"  (click)="alertService.warn('A snackbar test', {'autoclose':true, 'AlertType':'warning'})">Snackbar warn</button>
          <br>
            <button style="margin:5px" mat-flat-button color="warn"    (click)="alertService.info('info', { 'autoClose': true })">Info</button>
            <br>
              <button mat-flat-button color="primary" (click)="closeSnackBar()">Close Snackbar</button>

            </div> -->
